import $ from 'jquery';

  $(function() {

    var minHeight = parseInt(0);

    $(".partner-signpost-cmp .event-card__title").each(function(){
        if($(this).outerHeight() > minHeight){
            minHeight = $(this).outerHeight();
        }
    });
    $('.partner-signpost-cmp .event-card__title').css('height', minHeight);

    $(".partner-signpost-cmp .event-card__text").each(function(){
        if($(this).outerHeight() > minHeight){
            minHeight = $(this).outerHeight();
        }
    });
    $('.partner-signpost-cmp .event-card__text').css('height', minHeight);
});


// WEBPACK FOOTER //
// ./components/cwm-partner-offers-signpost/scripts/cwm-partner-offers-signpost.js